import { render, staticRenderFns } from "./RegisterRiderWelcome.vue?vue&type=template&id=fa84365a&scoped=true"
import script from "./RegisterRiderWelcome.vue?vue&type=script&lang=js"
export * from "./RegisterRiderWelcome.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderWelcome.vue?vue&type=style&index=0&id=fa84365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa84365a",
  null
  
)

export default component.exports